// src/routes.mjs — which URLs are the app; everything else is the
// marketing site. Shared by src/index.jsx and scripts/prerender.mjs.
export const APP_PATHS = ['/app', '/studio', '/prompter', '/monitor', '/remote', '/slate', '/tally', '/crew', '/approve', '/join', '/start', '/checkout']

export const isAppPath = (pathname, search = '') =>
  new URLSearchParams(search).get('output') === '1' ||
  APP_PATHS.includes(pathname.replace(/\/+$/, '') || '/')
